export default { sha: '30c273c4d75dedb53fb0b479639ef1b4b39e1329', buildNumber: 'undefined' }
